module.exports = __webpack_public_path__ + "static/media/csu-thumb.247f3385.png";